module.exports = __webpack_public_path__ + "static/media/6.5fdf4fab.jpg";